import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SimTable, GlgTableCol } from 'SharedComponents'
import LeagueRowHub from './league_row_hub'

const EventsTable = ({
  events,
  handlePublish,
  handleRegistration,
  handleChangePage,
  onSort,
}) => {
  const [dimension, setDimension] = useState(window.innerWidth)
  
  useEffect(() => {
    const handleResize = () => setDimension(window.innerWidth)
    window.addEventListener('resize', handleResize, false)
    return () => window.removeEventListener('resize', handleResize, false)
  }, [])

  const rowExtraProps = {
    handlePublish,
    handleRegistration,
    dimension,
  }

  const handleScroll = (e) => {
    const currentScrollAmount = Math.round(e.target.scrollHeight - e.target.scrollTop)
    const currentScrollPosition =
      currentScrollAmount <= e.target.clientHeight
        ? e.target.clientHeight
        : currentScrollAmount
    const marginError = e.target.clientHeight / 100
    const bottom = currentScrollPosition >= (e.target.clientHeight - marginError) && currentScrollPosition <= (e.target.clientHeight + marginError)
    if (bottom) {
      handleChangePage()
    }
  }

  return (
    <div className='list_container tm-table-container' onScroll={handleScroll}>
      <SimTable
        items={ events }
        rowComponent={ LeagueRowHub }
        rowExtraProps={ rowExtraProps }
        categoryColor={ [] }
        onSort={ onSort }
        fixedLayout
        className={ dimension <= 992 ? 'responsive_table_sim_golf' : '' }
      >
        <GlgTableCol width='25%' dataKey='name'>{window.I18n.t('gg_golf_hub.dashboard.table.name')}</GlgTableCol>
        <GlgTableCol width='10%' dataKey='golfers'>{window.I18n.t('gg_golf_hub.dashboard.table.golfers')}</GlgTableCol>
        <GlgTableCol width='15%' dataKey='startDate'>{window.I18n.t('gg_golf_hub.dashboard.table.start_date')}</GlgTableCol>
        <GlgTableCol width='15%' dataKey='status'>{window.I18n.t('gg_golf_hub.dashboard.table.status')}</GlgTableCol>
        <GlgTableCol width='10%' dataKey='link'>{window.I18n.t('gg_golf_hub.dashboard.table.link')}</GlgTableCol>
        <GlgTableCol width='15%' dataKey='registration'>{window.I18n.t('gg_golf_hub.dashboard.table.registration')}</GlgTableCol>
        <GlgTableCol width='10%' dataKey='actions'>{window.I18n.t('gg_golf_hub.dashboard.table.actions')}</GlgTableCol>
      </SimTable>
  </div>
  )
}

EventsTable.propTypes = {
  events: PropTypes.array,
  handlePublish: PropTypes.func,
  handleRegistration: PropTypes.func,
  handleChangePage: PropTypes.func,
  onSort: PropTypes.func,
}

export default EventsTable
